(function () {
  'use strict';

  /* @ngdoc object
   * @name crewViolations
   * @description
   *
   */
  angular
    .module('crewViolations', [
      'ui.router'
    ]);
}());
